import dayjs from "dayjs";
import type { components } from "@libertify/api-types/media";
import {
  PlaybookMediaSettings,
  PlaybookStoryboardSettings,
} from "../media/types";

type AspectRatio = components["schemas"]["AspectRatio"];

// Subset of API AspectRatio values that users can pick in the playbook form.
export const ASPECT_RATIO_OPTIONS = [
  "desktop",
  "tablet",
  "mobile",
] as const satisfies readonly AspectRatio[];

export type SelectableAspectRatio = (typeof ASPECT_RATIO_OPTIONS)[number];

export const isAspectRatio = (value: unknown): value is SelectableAspectRatio =>
  ASPECT_RATIO_OPTIONS.some((option) => option === value);

// Select value for a nullable boolean (used by transitions and auto-select
// music): "enabled" → true, "disabled" → false, "auto" → null (let the
// backend decide).
export type BooleanOption = "enabled" | "disabled" | "auto";

export type PlaybookFormValues = {
  name?: string;
  description?: string | null;
  language?: string | null;
  objectives?: PlaybookStoryboardSettings["objectives"] | null;
  brief?: string | null;
  image_style_description?: string | null;
  script_template_id?: string | null;
  highlights_template_id?: string | null;
  generation_date?: dayjs.Dayjs | null;
  contact_id?: string | null;
  brand_kit_id?: string | null;
  aspect_ratio?: SelectableAspectRatio;
  theme_id?: string | null;
  transitions?: BooleanOption;
  auto_select_music?: BooleanOption;
  video_sourcing_enabled?: boolean;
  image_extraction_enabled?: boolean;
  image_sourcing_enabled?: boolean;
  preserve_original_doc?: boolean;
  storyboard_generation_mode?:
    | PlaybookStoryboardSettings["storyboard_generation_mode"]
    | null;
  media_generation_mode?: PlaybookMediaSettings["media_generation_mode"] | null;
  chat_mode?: PlaybookMediaSettings["chat_mode"] | null;
  publication_mode?: PlaybookMediaSettings["publication_mode"] | null;
  include_document_animations?: boolean;
  generate_brandkit?: boolean;
  generate_images_for_slides?: boolean;
  expiration_time?: dayjs.Dayjs | null;
  music_asset_id?: string | null;
  cta_group_id?: string | null;
  instance_slug?: string | null;
  password?: string | null;
  selected_pages?: string | null;
  generate_emotions?: boolean;
};
